import React from "react";
import { Grid } from "@mui/material";
import translations from "../../config/language";

const language = process.env.REACT_APP_LANGUAGE;

const FarmingDetails = ({ selectedFarmer }) => {
    return (
        <div className="user-profile">
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", paddingLeft:"20px"}}>
                    {translations[language].educationLevel}
                </Grid>
                <Grid item lg={8} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}>
                    Tertiary
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].farmingExperience}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>16 Years</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft:"20px" }}>{translations[language].typesOfCrops}</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].cereals}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>Rice</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].legumes}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>Cowpea</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].rootsAndTubers}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>Tomatoes</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].vegetables}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>Tomatoes</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].fruits}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>Mango</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].cashCrops}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>Cocoa</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>{translations[language].typesOfLivestock}</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].cattle}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>Beef cattle: 03</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].poultry}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>Chickens: 02</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].smallRuminants}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>Goats: 05</Grid>
            </Grid>
        </div>
    );
};

export default FarmingDetails;
